type Method = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

const FALLBACK_MESSAGE = 'مشکلی پیش آمد. لطفاً دوباره تلاش کنید.'

export class RequestError extends Error {
    status: number

    constructor(message: string, status: number) {
        super(message)
        this.name = 'RequestError'
        this.status = status
    }
}

export const apiRequest = async <T>(url: string, method: Method = 'GET', body?: unknown): Promise<T> => {
    const init: RequestInit = {
        method,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
    }

    if (method !== 'GET') {
        init.headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' }
        init.body = JSON.stringify(body ?? {})
    }

    let response: Response

    try {
        response = await fetch(url, init)
    }
    catch {
        throw new RequestError('اتصال برقرار نشد. اینترنت خود را بررسی کنید و دوباره تلاش کنید.', 0)
    }

    const data = await response.json().catch(() => null) as (T & { message?: string }) | null

    if (!response.ok) throw new RequestError(data?.message || FALLBACK_MESSAGE, response.status)

    return data as T
}

export const errorMessage = (error: unknown): string =>
    error instanceof Error && error.message ? error.message : FALLBACK_MESSAGE
